import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../updateAction';
import { isEmail } from 'validator';

import BackButton from '../components/BackButton';
import Button from '../components/Button';
import Input from '../components/Input';
import StackForm from '../components/StackForm';
import Title from '../components/Title';

import useStore from '../store';
import { getMostrarReferidos } from '../config';
import { getButtonId, getParameters } from '../functions';
import { click_next_step1 } from '../techspec';

const Data = props => {
  const { register, errors, handleSubmit, triggerValidation } = useForm({
    mode: 'onBlur',
  });
  const [store, setStore] = useStore();
  const { action, state } = useStateMachine(updateAction);
  const [loadingReferidos, setLoadingReferidos] = useState(false);
  const [urlData, setUrlData] = useState('');

  const [name, setName] = useState(state?.data?.name || '');
  const [surname, setSurname] = useState(state?.data?.surname || '');

  useEffect(() => {
    // servicio que obtiene el valor de mostrarReferidos
    setLoadingReferidos(true);
    getMostrarReferidos()
      .then(response => {
        if (response && response.data) {
          setStore({ mostrarReferidos: response.data.mostrarReferidos });
          setLoadingReferidos(false);
        }
      })
      .catch(() => setLoadingReferidos(false));
  }, []);

  useEffect(() => {
    const parametros = getParameters();
    setUrlData({ step: '/1', tipo: parametros?.tipo });
  }, []);

  const onSubmit = data => {
    click_next_step1();
    action(data);
    props.history.push('/2');
  };

  useEffect(() => {
    setStore({ personName: `${name} ${surname}` || '' });
  }, [setStore, name, surname]);

  const preventSpecialChars = event => {
    const regex = new RegExp('[A-Za-z0-9\\s ñ]+$');
    const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  };

  // const removeSpecialCharsOnPaste = event => {
  //   const regex = new RegExp('[A-Za-z0-9\\s ñ]+$');
  //   document.querySelector(event.target).value = event.target.value.replace(regex, '');
  // }

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title>Para empezar tu solicitud decinos cómo te llamás.</Title>

        <Input
          type="text"
          label="Primer nombre"
          placeholder="Juan"
          id="name"
          name="name"
          defaultValue={state?.data?.name}
          register={register({ required: 'Este campo es obligatorio.' })}
          error={errors.name}
          focusOnMount={true}
          onChange={e => {
            setName(e.target.value);
            setStore({ personName: `${e.target.value} ${surname}` });
          }}
          onKeyPress={preventSpecialChars}
          // onPaste={removeSpecialCharsOnPaste}
        />

        <Input
          type="text"
          label="Primer apellido"
          placeholder="Pérez"
          id="surname"
          name="surname"
          defaultValue={state?.data?.surname}
          register={register({ required: 'Este campo es obligatorio.' })}
          error={errors.surname}
          onChange={e => {
            setSurname(e.target.value);
            setStore({ personName: `${name} ${e.target.value}` });
          }}
          onKeyPress={preventSpecialChars}
          // onPaste={removeSpecialCharsOnPaste}
        />

        <Input
          type="email"
          label="E-mail"
          placeholder="juanperez@mail.com"
          id="email"
          name="email"
          defaultValue={state?.data?.email}
          register={register({
            required: 'Este campo es obligatorio.',
            validate: value => (isEmail(value) ? true : 'E-mail inválido.'),
          })}
          error={errors.email}
          hint="Recordá que este es el mail dónde recibirás tus próximos estados de cuenta"
        />

        <Input
          type="tel"
          label="Celular"
          placeholder="09X-XXX-XXX"
          mask={{ blocks: [3, 3, 3], delimiter: '-', numericOnly: true }}
          id="phone"
          name="phone"
          defaultValue={state?.data?.phone}
          register={register({
            required: 'Este campo es obligatorio.',
            minLength: { value: 9, message: 'Debe tener 9 números.' },
            maxLength: { value: 9, message: 'Debe tener 9 números.' },
            validate: value => (value[0] == 0 && value[1] == 9 ? true : `Debe comenzar con 09`),
          })}
          error={errors.phone}
          triggerValidation={() => triggerValidation('phone')}
        />
      </div>

      <div className="form-actions">
        <Button
          block
          type="submit"
          id={
            urlData && getButtonId(urlData?.tipo, '/1')
              ? getButtonId(urlData?.tipo, '/1')
              : 'next-button-step-1'
          }
          disabled={loadingReferidos}
        >
          Siguiente
        </Button>

        <BackButton
          onClick={() => document.referrer && (window.location.href = document.referrer)}
        />
      </div>
    </StackForm>
  );
};

export default withRouter(Data);
